{
  "updating-accounts": "Updating your accounts...",
  "assets-title": "Assets",
  "assets-total": "Total Assets",
  "business-subtitle": "Business",
  "debts-title": "Debts",
  "debts-total": "Total Debts",
  "reports-title": "Reports",
  "total-household-income": "Total Household Income",
  "element-client-mobile-net-worth": "Net Worth",
  "element-client-mobile-graph-filter-past-all": "All",
  "element-client-mobile-graph-filter-past-1-year": "1y",
  "element-client-mobile-graph-filter-past-6-months": "6m",
  "element-client-mobile-graph-filter-past-3-months": "3m"
}
